<template>
  <div class="mt-2">
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Demo requests</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Demo Request</span>
          </v-card-title>

          <v-card-text>
            
              
                <v-layout row>
                  <v-flex xs8>
                    <v-subheader class="text-black font-weight-bold">First Name</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <p>{{ editedItem.first_name }}</p>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs8>
                    <v-subheader class="text-black font-weight-bold">Last Name</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <p>{{ editedItem.last_name }}</p>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs8>
                    <v-subheader class="text-black font-weight-bold">Email</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <p>{{ editedItem.email }}</p>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs8>
                    <v-subheader class="text-black font-weight-bold">Phone</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <p>{{ editedItem.phone }}</p>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs8>
                    <v-subheader class="text-black font-weight-bold">Subject</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <p>{{ editedItem.subject }}</p>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs8>
                    <v-subheader class="text-black font-weight-bold">Requesting Info</v-subheader>
                  </v-flex>
                  <v-flex xs4>
                    <p>{{ editedItem.requesting_info }}</p>
                  </v-flex>
                </v-layout>
              
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <!-- <v-btn color="blue darken-1" flat @click="save">Save</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.requests"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.first_name }}</td>
        <td class="text-xs-center">{{ props.item.last_name }}</td>
        <td class="text-xs-center">{{ props.item.email }}</td>
        <td class="text-xs-center">{{ props.item.phone }}</td>
        <td class="text-xs-center">{{ props.item.subject }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            visibility
          </v-icon>
          <v-icon small @click="deleteItem(props.item)"> delete </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    search: "",
    apiUrl: "request-demo",
    headers: [
      {
        text: "ID",
        align: "center",
        value: "id",
      },
      {
        text: "First Name",
        align: "center",
        sortable: false,
        value: "first_name",
      },
      {
        text: "Last Name",
        align: "center",
        sortable: false,
        value: "last_name",
      },
      {
        text: "Email",
        align: "center",
        sortable: false,
        value: "email",
      },
      { text: "Phone", align: "center", value: "phone" },
      { text: "Subject", align: "center", value: "subject" },

      { text: "Actions", align: "center", value: "actions" },
    ],
    editedIndex: -1,
    editedItem: {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      subject: "",
      requesting_info: "",
    },
    defaultItem: {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      subject: "",
      requesting_info: "",
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
      "userImage",
      "docImage",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "New Division" : "Edit Division";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex = this.indexData.requests.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.indexData.requests.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.indexData.requests.splice(index, 1);
      this.$store.dispatch("delete", [this.apiUrl, item.id]);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
      } else {
        this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
      }
      this.close();
    },
  },
};
</script>
